module.exports = __webpack_public_path__ + "068cceab4a5efe9f296e8c1584f3d017.png";